import api from "./api";

export const dashboard = async () => {
    const { data } = await api.get('/manager/dashboard/');

    return data
}

export const partnerDashboard = async () => {
    const { data } = await api.get('/manager/partner/dashboard/');

    return data
}

export const graph = async (type: string, month: number) => { 
    const { data } = await api.get(`/manager/graph/${type}/${month}/`)

    return data
}